import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import ButtonRounded from "../../../../components/ButtonRounded";
import ToggleButton from "../../../../components/ToggleButton";
import { makeStyles, createStyles, Theme, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import getConfirmState from "../../../../api/sustainability/reports/getConfirmState";
import getDownloadReport, {
  Tfiletype,
} from "../../../../api/sustainability/reports/getDownloadReport";
import ModalInfo from "../../../../components/modal/ModalInfo";
import ModalConfirmDelivery from "./ModalConfirmDelivery";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import Select from "@material-ui/core/Select";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import MenuItem from "@material-ui/core/MenuItem";
import { getOffroadDraftReport } from "../../../../api/sustainability/DraftReports/offroad/getOffroadDraftReport";
import {useHistory} from "react-router-dom";
import parseAndFormat from "../../../../components/texts/parseAndFormat";
import { brandColors } from "../../../../theme";

import MuiExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const ExpansionPanel = withStyles((theme: Theme) => ({
    root: {
        marginBottom: theme.spacing(2),
        "&.Mui-expanded:last-child": {
            marginBottom: theme.spacing(2),
        },
        "&.MuiExpansionPanel-root:before": { backgroundColor: "transparent" },
    },
}))(MuiExpansionPanel);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& .MuiOutlinedInput-input": {
        padding: theme.spacing(1),
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
        fontSize: "14px",
      },
    },
    titleSection: {
      marginBottom: theme.spacing(3),
    },
    h2: {
      [theme.breakpoints.down("md")]: {
        fontSize: "32px",
      },
    },
    select: {
      width: "150px",
      [theme.breakpoints.down("md")]: {
        width: "100px",
      },
    },
    sectionDownloads: {
      marginBottom: theme.spacing(2),
    },
    section: {
      marginBottom: theme.spacing(3),
      "&:last-child": {
        marginBottom: 0,
      },
    },
    card: {
      height: "100%",
    },
    cardContent: {
      padding: theme.spacing(3.75),
      paddingTop: theme.spacing(4),
      "&:last-child": {
        paddingBottom: theme.spacing(3.75),
      },
    },
    topSpacing: {
      marginTop: theme.spacing(2),
    },
    cardTitle: {
      marginBottom: theme.spacing(0.5),
    },
    cardTitleRed: {
      marginBottom: theme.spacing(0.5),
      color: theme.palette.error.main,
    },
    cardSubTitle: {
      fontSize: theme.typography.h5.fontSize,
      marginBottom: theme.spacing(2.5),
      marginTop: theme.spacing(2),
    },
    table: {
      "& .MuiTableBody-root .MuiTableRow-root:nth-child(odd)": {
        backgroundColor: theme.palette.grey[50],
      },
      "& .MuiTableCell-root": {
        border: "none",
        paddingTop: 0,
        paddingBottom: 0,
        height: theme.spacing(4),
      },
      "& .MuiTableCell-head": {
        color: "inherit",
        fontSize: "12px",
        fontWeight: 700,
        backgroundColor: theme.palette.grey[300],
      },
    },
    tableContainer: {
      maxHeight: "450px",
      overflowY: "auto", // "scroll",
      "& .MuiOutlinedInput-input": {
        ...theme.typography.caption,
        fontWeight: 500,
        color: theme.palette.primary.main,
      },
    },
    btnDownloads: {
      height: "100%",
    },
    circularProgress: {
      margin: "80px",
      width: "48px",
      height: "48px",
    },
    noData: {
      textAlign: 'center',
      padding: '16px',
      color: '#777',
    },
  })
);

interface Props {
  activePeriod: any;
  isSimulation: boolean;
  isJoint: boolean;
  toggleSimulation: any;
  data: any;
  getPageData: any;
  isFetching: boolean;
  taxPeriods: any[];
  selectedYear: number;
  setSelectedYear: any;
}

const ReportsView: React.FC<Props> = ({
                                        activePeriod,
                                        isSimulation,
                                        isJoint,
                                        toggleSimulation,
                                        data,
                                        getPageData,
                                        isFetching,
                                        taxPeriods,
                                        selectedYear,
                                        setSelectedYear,
                                      }) => {
  const [expanded, setExpanded] = useState<string[]>([]);

  const handleAccordionChange = (panel: string) => (
      event: React.ChangeEvent<{}>,
      isExpanded: boolean
  ) => {
    setExpanded(isExpanded 
      ? [...expanded, panel]
      : expanded.filter(item => item !== panel)
    );
  };

  const history = useHistory();
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [showErrorModal, setShowErrorModal] = useState<boolean>(false);
  const [selectedPart, setSelectedPart] = useState<any>(activePeriod.name);
  const [report, setReport] = useState(null);
  const [
    showConfirmDeliveryModal,
    setShowConfirmDeliveryModal,
  ] = useState<boolean>(false);

  const openErrorModal = (msg: string) => {
    setErrorMessage(msg);
    setShowErrorModal(true);
  };
  const closeErrorModal = () => {
    setErrorMessage("");
    setShowErrorModal(false);
  };

  const openConfirmDeliveryModal = () => {
    setShowConfirmDeliveryModal(true);
  };

  const closeConfirmDeliveryModal = () => {
    setShowConfirmDeliveryModal(false);
  };

  const classes = useStyles();

  const handleDownload = async (type: Tfiletype) => {
    const response = await getDownloadReport({
      type,
      mandate_type: "offroad",
      taxYear: selectedYear,
    });
    if (response === null) {
      openErrorModal(
          "Failed to download file: Possible errors: no file for selected year or other errors."
      );
    }

    if (response !== null) {
      // emulate file download by clicking on an <a /> link
      const url = window.URL.createObjectURL(response);
      const fileName =
          type === "draft_report_excel"
              ? "sustainability-draft-report"
              : type.indexOf("sub") > -1
                  ? "sustainability-subreport"
                  : "sustainability-report";
      const fileExt = type.indexOf("excel") > -1 ? "xlsx" : "json";

      const a = document.createElement("a");
      a.href = url;
      a.download = `${fileName}-offroad-${selectedYear}.${fileExt}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    }
  };

  const handleConfirmationStatus = async () => {
    const res = await getConfirmState({ taxYear: selectedYear });
    if (res === null) {
      openErrorModal(
          "Failed to confirm delivery. Possible errors: correct reporting year is not selected or other errors."
      );
    } else {
      openErrorModal(
          "Delivery Confirmed."
      );
      getPageData(selectedYear);
    }
  };

  useEffect(() => {
    const fetchReport = async () => {
      const data = await getOffroadDraftReport();
      if (data) {
        setReport(data);
      } else {
      }
    };

    fetchReport();
  }, []);

  // on init
  useEffect(() => {
    setSelectedYear(activePeriod.year);
  }, []);

  useEffect(() => {
    getPageData(selectedYear);
  }, [selectedYear]);

  const getCellColor = (cellValue: any) => {
    if (!cellValue) {
        return "#a1aeb7";
    } else if (cellValue == "N/A" || cellValue == 0 || cellValue == "") {
        return "#a1aeb7";
    } else {
        return "#424b5a";
    }
  };

  // report overview
  const goToReportOverview = () => {
    history.push(`/sustainability/reportoverview/`);
  };

  // @ts-ignore
  if (!report || !report.data || !report.data.mandate_fulfillment_status || !report.data.mandate_fulfillment_status.fulfillment_status) {
    return <p></p>;
  }

  // @ts-ignore
  const mandateFulfillmentStatus = report.data.mandate_fulfillment_status;
  // @ts-ignore
  const volumeSummary = report.data.volume_summary;
  // @ts-ignore
  const allocatedBatches = report.data.allocated_batches;
  // @ts-ignore
  const allocatedBatchesStepFive = report.data.allocated_batches_step_five;
  // @ts-ignore
  const allocationDetails = report.data.allocation_details;
  // @ts-ignore
  const surplusOverview = report.data.surplus_overview;

  const bgColorGreen = brandColors.success.bg;
  const bgColorYellow = brandColors.primary.light;
  const bgColorRed = brandColors.secondary.bg;
  const bgColorGray = "#C2D1D9";

  let colorDetailsGeneral = bgColorGray;
  if (allocationDetails.general_mandate_status === "OK") {
    colorDetailsGeneral = bgColorGreen;
  } else {
    colorDetailsGeneral = bgColorRed;
  }

  let colorDetailsLockedSurplus = bgColorGray;
  if (allocationDetails.locked_surplus_status === "OK") {
    colorDetailsLockedSurplus = bgColorGreen;
  } else {
    colorDetailsLockedSurplus = bgColorRed;
  }

  let colorDetailsAvailableSurplus = bgColorGray;
  if (allocationDetails.mandate_surplus_available_status === "OK") {
    colorDetailsAvailableSurplus = bgColorGreen;
  } else {
    colorDetailsAvailableSurplus = bgColorRed;
  }

  let colorDetailsConventional = bgColorGray;
  if (allocationDetails.total_conventional_biofuel_status === "OK") {
    colorDetailsConventional = bgColorGreen;
  } else {
    colorDetailsConventional = bgColorRed;
  }

  let colorDetailsVolume = bgColorGray;
  if (allocationDetails.volume_check_status === "VOLUME MATCH") {
    colorDetailsVolume = bgColorGreen;
  } else {
    colorDetailsVolume = bgColorRed;
  }

  let statusColorGeneral = bgColorGreen;
  if (mandateFulfillmentStatus.fulfillment_status.general_mandate === "Not fulfilled") {
    statusColorGeneral = bgColorRed;
  } else if (mandateFulfillmentStatus.fulfillment_status.general_mandate === "Over-allocated") {
    statusColorGeneral = bgColorYellow;
  }  else if (mandateFulfillmentStatus.fulfillment_status.general_mandate === "Not relevant") {
    statusColorGeneral = "#f0f0f0";
  }

  let statusColorReqByCust = bgColorGreen;
  if (mandateFulfillmentStatus.fulfillment_status.req_by_cust_mandate_15 === "Not fulfilled") {
    statusColorReqByCust = bgColorRed;
  } else if (mandateFulfillmentStatus.fulfillment_status.req_by_cust_mandate_15 === "Over-allocated") {
    statusColorReqByCust = bgColorYellow;
  }  else if (mandateFulfillmentStatus.fulfillment_status.req_by_cust_mandate_15 === "Not relevant") {
    statusColorReqByCust = "#f0f0f0";
  }

  let statusColorOutJoint = bgColorGreen;
  if (mandateFulfillmentStatus.fulfillment_status.out_joint_fulfillment === "Not fulfilled") {
    statusColorOutJoint = bgColorRed;
  } else if (mandateFulfillmentStatus.fulfillment_status.out_joint_fulfillment === "Over-allocated") {
    statusColorOutJoint = bgColorYellow;
  }  else if (mandateFulfillmentStatus.fulfillment_status.out_joint_fulfillment === "Not relevant") {
    statusColorOutJoint = "#f0f0f0";
  }

  let statusColorAfterFulfill = bgColorGreen;
  if (mandateFulfillmentStatus.fulfillment_status.after_mandate_fulfill_15 === "Not fulfilled") {
    statusColorAfterFulfill = bgColorRed;
  } else if (mandateFulfillmentStatus.fulfillment_status.after_mandate_fulfill_15 === "Over-allocated") {
    statusColorAfterFulfill = bgColorYellow;
  }  else if (mandateFulfillmentStatus.fulfillment_status.after_mandate_fulfill_15 === "Not relevant") {
    statusColorAfterFulfill = "#f0f0f0";
  }

  let statusColorNotApplicableToMandate = bgColorGreen;
  if (mandateFulfillmentStatus.fulfillment_status.not_applicable_to_mandate === "Not fulfilled") {
    statusColorNotApplicableToMandate = bgColorRed;
  } else if (mandateFulfillmentStatus.fulfillment_status.not_applicable_to_mandate === "Over-allocated") {
    statusColorNotApplicableToMandate = bgColorYellow;
  }  else if (mandateFulfillmentStatus.fulfillment_status.not_applicable_to_mandate === "Not relevant") {
    statusColorNotApplicableToMandate = "#f0f0f0";
  }

  return (
    <div className={classes.root}>
    <Grid
      container
      justify="space-between"
      alignItems="center"
      className={classes.titleSection}
    >
      <Grid item>
        <Typography variant="h2" className={classes.h2}>
          Draft report: <span style={{ color: brandColors.primary.main }}>Off-road</span>
        </Typography>
      </Grid>
      <Grid item>
        <Grid container spacing={2} alignItems="center">
          {!isFetching &&
            data &&
            data.tax_year_seq &&
            data.tax_year_seq.length > 1 && (
              <Grid item>
                <Select
                  fullWidth
                  className={classes.select}
                  input={<OutlinedInput labelWidth={0} />}
                  value={selectedPart}
                  onChange={e => setSelectedPart(e.target.value)}
                >
                  {data.tax_year_seq.map(
                    (partName: string, index: number) => (
                      <MenuItem value={partName}>
                        {"Part " +
                          partName
                            .replace(selectedYear + "", "")
                            .match(/\d+/)}
                      </MenuItem>
                    )
                  )}
                </Select>
              </Grid>
            )}

          <Grid item>
            <Select
              fullWidth
              className={classes.select}
              input={<OutlinedInput labelWidth={0} />}
              value={selectedYear}
              onChange={e => setSelectedYear(e.target.value)}
            >
              {taxPeriods
                ? taxPeriods.map((year: any, index: number) => (
                    <MenuItem
                      value={Object.keys(year)[0]}
                      key={
                        "Sus.View_Reports_Year_" +
                        Object.keys(year)[0] +
                        "-" +
                        index
                      }
                    >
                      {Object.keys(year)[0]}
                    </MenuItem>
                  ))
                : null}
            </Select>
          </Grid>

          <Grid item>
            <ToggleButton
              labels={["Reporting", "Simulation"]}
              defaultLabelIndex={isSimulation ? 1 : 0}
              size="small"
              bgWhite
              handleChange={toggleSimulation}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
    <Grid container spacing={2} className={classes.sectionDownloads}>
      <Grid item xs={7}>
        <Card className={classes.card}>
          <CardContent className={classes.cardContent}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h5" className={classes.cardTitle}>
                  Allocation Mode: <span style={{ color: brandColors.primary.main }}>{isSimulation ? "Simulation" : "Reporting"}</span>
                </Typography>
                <Typography variant="h5" className={classes.cardTitle}>
                  Period: <span style={{ color: brandColors.primary.main }}>{activePeriod.year}</span>
                </Typography>
                <Typography variant="h5" className={classes.cardTitle}>
                  Fulfillment type: <span style={{ color: brandColors.primary.main }}>{mandateFulfillmentStatus.joint_fulfillment.is_joint ? "Joint" : "Own"}</span>
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={5}>
        <Card className={classes.card}>
          <CardContent className={classes.cardContent}>
            <Typography variant="h5" className={classes.cardTitle}>
              <p>Report File and Actions</p>
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={4} style={{padding: "7px"}}>
                <ButtonRounded
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => handleDownload("draft_report_excel")}
                >
                  Draft Report (Excel)
                </ButtonRounded>
              </Grid>
              <Grid item xs={4} style={{padding: "7px"}}>
                <ButtonRounded
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => handleDownload("report_excel")}
                >
                  Tilde report file
                </ButtonRounded>
              </Grid>
              <Grid item xs={4} style={{padding: "7px"}}>
                <ButtonRounded
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={goToReportOverview}
                    disabled={false}
                >
                  Report overview
                </ButtonRounded>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
    {isFetching ? (
      <Box
        flex={1}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <CircularProgress className={classes.circularProgress} />
      </Box>
    ) : (
      <div>
        <ExpansionPanel expanded={expanded.includes("mandate")} onChange={handleAccordionChange("mandate")}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h5" className={classes.cardTitle}>
              Fulfillment status
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Table className={classes.table}>
              <TableHead className="MuiTableCell-head">
                <TableRow>
                  <TableCell>Fulfillment status</TableCell>
                  <TableCell>Requirement</TableCell>
                  <TableCell>Required Volume</TableCell>
                  <TableCell>Joint fulfillment IN</TableCell>
                  <TableCell>Flexibility surplus IN</TableCell>
                  <TableCell>Allocated(L15)</TableCell>
                  <TableCell>Remaining volume</TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="MuiTableBody-root">
                <TableRow>
                  <TableCell style={{backgroundColor: statusColorGeneral}}>{mandateFulfillmentStatus.fulfillment_status.general_mandate}</TableCell>
                  <TableCell style={{backgroundColor: statusColorGeneral}}>General Mandate ({mandateFulfillmentStatus.requirement.general_mandate}%)</TableCell>
                  <TableCell style={{backgroundColor: statusColorGeneral}}>{parseAndFormat(mandateFulfillmentStatus.req_vol.general_mandate, 2)}</TableCell>
                  <TableCell style={{backgroundColor: statusColorGeneral}}>{
                    mandateFulfillmentStatus.joint_fulfillment.general_mandate === "N/A" ? "N/A" : parseAndFormat(mandateFulfillmentStatus.joint_fulfillment.general_mandate, 2)
                  }</TableCell>
                  <TableCell style={{backgroundColor: statusColorGeneral}}>{parseAndFormat(mandateFulfillmentStatus.surplus.general_mandate, 2)}</TableCell>
                  <TableCell style={{backgroundColor: statusColorGeneral}}>{parseAndFormat(mandateFulfillmentStatus.allocated_15.general_mandate_15, 2)}</TableCell>
                  <TableCell style={{backgroundColor: statusColorGeneral}}>{parseAndFormat(mandateFulfillmentStatus.remaining_volume.general_mandate, 2)}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{backgroundColor: statusColorReqByCust}}>{mandateFulfillmentStatus.fulfillment_status.req_by_cust_mandate_15}</TableCell>
                  <TableCell style={{backgroundColor: statusColorReqByCust}}>Above the mandate (required by customers)</TableCell>
                  <TableCell style={{backgroundColor: statusColorReqByCust}}>{parseAndFormat(mandateFulfillmentStatus.req_vol.req_by_cust_mandate, 2)}</TableCell>
                  <TableCell style={{backgroundColor: statusColorReqByCust}}>{mandateFulfillmentStatus.joint_fulfillment.req_by_cust_mandate}</TableCell>
                  <TableCell style={{backgroundColor: statusColorReqByCust}}>{mandateFulfillmentStatus.surplus.req_by_cust_mandate}</TableCell>
                  <TableCell style={{backgroundColor: statusColorReqByCust}}>{parseAndFormat(mandateFulfillmentStatus.allocated_15.req_by_cust_mandate_15, 2)}</TableCell>
                  <TableCell style={{backgroundColor: statusColorReqByCust}}>{parseAndFormat(mandateFulfillmentStatus.remaining_volume.req_by_cust_mandate, 2)}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{backgroundColor: statusColorOutJoint}}>{mandateFulfillmentStatus.fulfillment_status.out_joint_fulfillment}</TableCell>
                  <TableCell style={{backgroundColor: statusColorOutJoint}}>Joint Fulfillment OUT</TableCell>
                  <TableCell style={{backgroundColor: statusColorOutJoint}}>{parseAndFormat(mandateFulfillmentStatus.req_vol.out_joint_fulfillment, 2)}</TableCell>
                  <TableCell style={{backgroundColor: statusColorOutJoint}}>{mandateFulfillmentStatus.joint_fulfillment.out_joint_fulfillment}</TableCell>
                  <TableCell style={{backgroundColor: statusColorOutJoint}}>{mandateFulfillmentStatus.surplus.out_joint_fulfillment}</TableCell>
                  <TableCell style={{backgroundColor: statusColorOutJoint}}>{parseAndFormat(mandateFulfillmentStatus.allocated_15.out_joint_fulfillment, 2)}</TableCell>
                  <TableCell style={{backgroundColor: statusColorOutJoint}}>{parseAndFormat(mandateFulfillmentStatus.remaining_volume.out_joint_fulfillment, 2)}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{backgroundColor: statusColorAfterFulfill}}>{mandateFulfillmentStatus.fulfillment_status.after_mandate_fulfill_15}</TableCell>
                  <TableCell style={{backgroundColor: statusColorAfterFulfill}}>Above the mandate (after mandate fulfillment)</TableCell>
                  <TableCell style={{backgroundColor: statusColorAfterFulfill}}>{parseAndFormat(mandateFulfillmentStatus.req_vol.after_mandate_fulfill, 2)}</TableCell>
                  <TableCell style={{backgroundColor: statusColorAfterFulfill}}>{mandateFulfillmentStatus.joint_fulfillment.after_mandate_fulfill}</TableCell>
                  <TableCell style={{backgroundColor: statusColorAfterFulfill}}>{mandateFulfillmentStatus.surplus.after_mandate_fulfill}</TableCell>
                  <TableCell style={{backgroundColor: statusColorAfterFulfill}}>{parseAndFormat(mandateFulfillmentStatus.allocated_15.after_mandate_fulfill_15, 2)}</TableCell>
                  <TableCell style={{backgroundColor: statusColorAfterFulfill}}>{parseAndFormat(mandateFulfillmentStatus.remaining_volume.after_mandate_fulfill, 2)}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{backgroundColor: statusColorNotApplicableToMandate}}>{mandateFulfillmentStatus.fulfillment_status.not_applicable_to_mandate}</TableCell>
                  <TableCell style={{backgroundColor: statusColorNotApplicableToMandate}}>Not applicable to Mandate</TableCell>
                  <TableCell style={{backgroundColor: statusColorNotApplicableToMandate}}>{parseAndFormat(mandateFulfillmentStatus.req_vol.not_applicable_to_mandate, 2)}</TableCell>
                  <TableCell style={{backgroundColor: statusColorNotApplicableToMandate}}>{
                    mandateFulfillmentStatus.joint_fulfillment.is_joint === false ? "N/A" : parseAndFormat(mandateFulfillmentStatus.joint_fulfillment.not_applicable_to_mandate, 2)
                  }</TableCell>
                  <TableCell style={{backgroundColor: statusColorNotApplicableToMandate}}>{
                    mandateFulfillmentStatus.joint_fulfillment.is_joint === false ? "N/A" : parseAndFormat(mandateFulfillmentStatus.surplus.not_applicable_to_mandate, 2)
                  }</TableCell>
                  <TableCell style={{backgroundColor: statusColorNotApplicableToMandate}}>{parseAndFormat(mandateFulfillmentStatus.allocated_15.not_applicable_to_mandate, 2)}</TableCell>
                  <TableCell style={{backgroundColor: statusColorNotApplicableToMandate}}>{parseAndFormat(mandateFulfillmentStatus.remaining_volume.not_applicable_to_mandate, 2)}</TableCell>
                </TableRow>
              </TableBody>

            </Table>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel expanded={expanded.includes("batches")} onChange={handleAccordionChange("batches")}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h5" className={classes.cardTitle}>
              Sustainability batches
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails style={{ display: "block" }}>
            {Array.isArray(allocatedBatches) && allocatedBatches.length > 0 ? (
                <Table className={classes.table}>
                  <TableHead className="MuiTableCell-head">
                    <TableRow>
                      <TableCell style={{ width: "5%" }}>Batch#</TableCell>
                      <TableCell style={{ width: "10%" }}>Biofuel Type</TableCell>
                      <TableCell style={{ width: "10%" }}>Volume(L)</TableCell>
                      <TableCell style={{ width: "15%" }}>Raw material</TableCell>
                      <TableCell style={{ width: "5%" }}>Advanced</TableCell>
                      <TableCell style={{ width: "10%" }}>Origin</TableCell>
                      <TableCell style={{ width: "5%" }}>Ghg red.</TableCell>
                      <TableCell style={{ width: "10%" }}>Storage terminal</TableCell>
                      <TableCell style={{ width: "15%" }}>Certification scheme</TableCell>
                      <TableCell style={{ width: "10%" }}>Certification ID</TableCell>
                      <TableCell style={{ width: "5%" }}>Etot</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody className="MuiTableBody-root">
                    {
                      allocatedBatches.map((biotemplate: any, index: number) => (
                          <TableRow key={index}>
                            <TableCell style={{ width: "5%" }}>{index + 1}</TableCell>
                            <TableCell style={{ width: "10%" }}>{biotemplate.biofuel_type}</TableCell>
                            <TableCell style={{ width: "10%" }}>{parseAndFormat(biotemplate.volume, 2)}</TableCell>
                            <TableCell style={{ width: "15%" }}>{biotemplate.raw_material}</TableCell>
                            <TableCell style={{ width: "5%" }}>{biotemplate.double_counted_norway}</TableCell>
                            <TableCell style={{ width: "10%" }}>{biotemplate.raw_material_origin}</TableCell>
                            <TableCell style={{ width: "5%" }}>{parseAndFormat(biotemplate.reduction_in_climate_emission, 2)}</TableCell>
                            <TableCell style={{ width: "10%" }}>{biotemplate.storage_terminal}</TableCell>
                            <TableCell style={{ width: "15%" }}>{biotemplate.documentation_emission_of_climate}</TableCell>
                            <TableCell style={{ width: "10%" }}>{biotemplate.certification_id}</TableCell>
                            <TableCell style={{ width: "5%" }}>{parseAndFormat(biotemplate.etot, 2)}</TableCell>
                          </TableRow>
                      ))
                    }
                  </TableBody>
                </Table>
            ) : (
                <div className={classes.noData}>
                  No allocated biofuel batches
                </div>
            )}

            {allocatedBatchesStepFive && allocatedBatchesStepFive.length > 0 && (
                <>
                  <Typography variant="subtitle2" className={`${classes.cardTitleRed} ${classes.topSpacing}`}>
                    Batches not applicable to the mandate
                  </Typography>

                  <Table className={classes.table}>
                    <TableHead className="MuiTableCell-head">
                      <TableRow>
                        <TableCell style={{ width: "5%" }}>Batch#</TableCell>
                        <TableCell style={{ width: "10%" }}>Biofuel Type</TableCell>
                        <TableCell style={{ width: "10%" }}>Volume(L)</TableCell>
                        <TableCell style={{ width: "15%" }}>Raw material</TableCell>
                        <TableCell style={{ width: "5%" }}>Advanced</TableCell>
                        <TableCell style={{ width: "10%" }}>Origin</TableCell>
                        <TableCell style={{ width: "5%" }}>Ghg red.</TableCell>
                        <TableCell style={{ width: "10%" }}>Storage terminal</TableCell>
                        <TableCell style={{ width: "15%" }}>Certification scheme</TableCell>
                        <TableCell style={{ width: "10%" }}>Certification ID</TableCell>
                        <TableCell style={{ width: "5%" }}>Etot</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="MuiTableBody-root">
                      {
                        allocatedBatchesStepFive.map((biotemplate: any, index: number) => (
                            <TableRow key={index}>
                              <TableCell style={{ width: "5%" }}>{index + 1 + allocatedBatches.length}</TableCell>
                              <TableCell style={{ width: "10%" }}>{biotemplate.biofuel_type}</TableCell>
                              <TableCell style={{ width: "10%" }}>{parseAndFormat(biotemplate.volume, 2)}</TableCell>
                              <TableCell style={{ width: "15%" }}>{biotemplate.raw_material}</TableCell>
                              <TableCell style={{ width: "5%" }}>{biotemplate.double_counted_norway}</TableCell>
                              <TableCell style={{ width: "10%" }}>{biotemplate.raw_material_origin}</TableCell>
                              <TableCell style={{ width: "5%" }}>{parseAndFormat(biotemplate.reduction_in_climate_emission, 2)}</TableCell>
                              <TableCell style={{ width: "10%" }}>{biotemplate.storage_terminal}</TableCell>
                              <TableCell style={{ width: "15%" }}>{biotemplate.documentation_emission_of_climate}</TableCell>
                              <TableCell style={{ width: "10%" }}>{biotemplate.certification_id}</TableCell>
                              <TableCell style={{ width: "5%" }}>{parseAndFormat(biotemplate.etot, 2)}</TableCell>
                            </TableRow>
                        ))
                      }
                    </TableBody>
                  </Table>
                </>
            )}
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel expanded={expanded.includes("volume")} onChange={handleAccordionChange("volume")}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h5" className={classes.cardTitle}>
              Volume summary
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Table className={classes.table}>
              <TableHead className="MuiTableCell-head">
                <TableRow>
                  <TableCell>Diesel products</TableCell>
                  <TableCell>Sold volumes</TableCell>
                  <TableCell>Allocated volumes</TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="MuiTableBody-root">
                <TableRow>
                  <TableCell>Diesel</TableCell>
                  <TableCell>{parseAndFormat(volumeSummary.sold.diesel, 2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{width: "20%", borderBottom: "1px solid black"}}>Bio components</TableCell>
                  <TableCell style={{width: "20%", borderBottom: "1px solid black"}}>{parseAndFormat(volumeSummary.sold.biocomponent_in_diesel, 2)}</TableCell>
                  <TableCell style={{width: "20%", borderBottom: "1px solid black"}}>{parseAndFormat(volumeSummary.allocated.biocomponent_in_diesel, 2)}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Fame</TableCell>
                  <TableCell>{parseAndFormat(volumeSummary.sold.fame, 2)}</TableCell>
                  <TableCell>{parseAndFormat(volumeSummary.allocated.fame, 2)}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Fame (advanced)</TableCell>
                  <TableCell>{parseAndFormat(volumeSummary.sold.fame_advanced, 2)}</TableCell>
                  <TableCell>{parseAndFormat(volumeSummary.allocated.fame_advanced, 2)}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>HVO/HRO</TableCell>
                  <TableCell>{parseAndFormat(volumeSummary.sold.hvo_hro, 2)}</TableCell>
                  <TableCell>{parseAndFormat(volumeSummary.allocated.hvo_hro, 2)}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>HVO/HRO (advanced)</TableCell>
                  <TableCell>{parseAndFormat(volumeSummary.sold.hvo_hro_advanced, 2)}</TableCell>
                  <TableCell>{parseAndFormat(volumeSummary.allocated.hvo_hro_advanced, 2)}</TableCell>
                </TableRow>
              </TableBody>
              <TableHead>
                <TableRow>
                  <TableCell>Total diesel volume</TableCell>
                  <TableCell>{parseAndFormat(volumeSummary.sold.total_diesel, 2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
            </Table>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel expanded={expanded.includes("allocation")} onChange={handleAccordionChange("allocation")}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h5" className={classes.cardTitle}>
              Allocation details
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails style={{ display: "block" }}>
            <Table className={classes.table}>
              <TableHead className="MuiTableCell-head">
                <TableRow>
                  <TableCell style={{ width: "40%", backgroundColor: colorDetailsGeneral }}>General mandate</TableCell>
                  <TableCell style={{ width: "40%", backgroundColor: colorDetailsGeneral }}>{allocationDetails.general_mandate_status}</TableCell>
                  <TableCell style={{ width: "20%", backgroundColor: colorDetailsGeneral }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="MuiTableBody-root">
                <TableRow>
                  <TableCell style={{color: getCellColor(allocationDetails.general_mandate_requirement)}}>Calculated mandate requirement</TableCell>
                  <TableCell style={{color: getCellColor(allocationDetails.general_mandate_requirement)}}>{parseAndFormat(allocationDetails.general_mandate_requirement, 2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{color: getCellColor(allocationDetails.general_in_joint_adv)}}>Joint fulfillment IN advanced biofuel</TableCell>
                  <TableCell style={{color: getCellColor(allocationDetails.general_in_joint_adv)}}>{parseAndFormat(allocationDetails.general_in_joint_adv, 2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{color: getCellColor(allocationDetails.general_surplus)}}>Volume flexibility IN from road use mandate</TableCell>
                  <TableCell style={{color: getCellColor(allocationDetails.general_surplus)}}>{parseAndFormat(allocationDetails.general_surplus, 2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{color: getCellColor(allocationDetails.general_fame_adv)}}>Allocation advanced FAME</TableCell>
                  <TableCell style={{color: getCellColor(allocationDetails.general_fame_adv)}}>{parseAndFormat(allocationDetails.general_fame_adv, 2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{color: getCellColor(allocationDetails.general_hvo_adv)}}>Allocation advanced HVO/HRO</TableCell>
                  <TableCell style={{color: getCellColor(allocationDetails.general_hvo_adv)}}>{parseAndFormat(allocationDetails.general_hvo_adv, 2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableBody>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: "40%" }}>Remaining volume general mandate</TableCell>
                  <TableCell style={{ width: "40%" }}>{parseAndFormat(allocationDetails.general_remaining, 2)}</TableCell>
                  <TableCell style={{ width: "20%" }}></TableCell>
                </TableRow>
              </TableHead>
            </Table>
            <Table className={`${classes.table} ${classes.topSpacing}`}>
              <TableHead className="MuiTableCell-head">
                <TableRow>
                  <TableCell style={{ width: "40%", backgroundColor: colorDetailsLockedSurplus }}>Mandate Surplus LOCKED</TableCell>
                  <TableCell style={{ width: "40%", backgroundColor: colorDetailsLockedSurplus }}>{allocationDetails.locked_surplus_status}</TableCell>
                  <TableCell style={{ width: "20%", backgroundColor: colorDetailsLockedSurplus }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="MuiTableBody-root">
                <TableRow>
                  <TableCell style={{color: getCellColor(allocationDetails.total_locked_surplus)}}>Total volume locked surplus</TableCell>
                  <TableCell style={{color: getCellColor(allocationDetails.total_locked_surplus)}}>{parseAndFormat(allocationDetails.total_locked_surplus, 2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{color: getCellColor(allocationDetails.fame_adv_customer_req)}}>Advanced FAME required by customers</TableCell>
                  <TableCell style={{color: getCellColor(allocationDetails.fame_adv_customer_req)}}>{parseAndFormat(allocationDetails.fame_adv_customer_req, 2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{color: getCellColor(allocationDetails.hvo_adv_customer_req)}}>Advanced HVO/HRO required by customers</TableCell>
                  <TableCell style={{color: getCellColor(allocationDetails.hvo_adv_customer_req)}}>{parseAndFormat(allocationDetails.hvo_adv_customer_req, 2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{color: getCellColor(allocationDetails.out_joint_adv_locked)}}>Joint fulfillment OUT advanced biofuel</TableCell>
                  <TableCell style={{color: getCellColor(allocationDetails.out_joint_adv_locked)}}>{parseAndFormat(allocationDetails.out_joint_adv_locked, 2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableBody>
              <TableHead>
                <TableRow>
                  <TableCell>Remaining volume mandate surplus LOCKED</TableCell>
                  <TableCell>{parseAndFormat(allocationDetails.remaining_locked_surplus, 2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
            </Table>
            <Table className={`${classes.table} ${classes.topSpacing}`}>
              <TableHead className="MuiTableCell-head">
                <TableRow>
                  <TableCell style={{ width: "40%", backgroundColor: colorDetailsAvailableSurplus }}>Mandate surplus AVAILABLE</TableCell>
                  <TableCell style={{ width: "40%", backgroundColor: colorDetailsAvailableSurplus }}>{allocationDetails.mandate_surplus_available_status}</TableCell>
                  <TableCell style={{ width: "20%", backgroundColor: colorDetailsAvailableSurplus }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="MuiTableBody-root">
                <TableRow>
                  <TableCell style={{color: getCellColor(allocationDetails.total_available_surplus)}}>Total volume available surplus</TableCell>
                  <TableCell style={{color: getCellColor(allocationDetails.total_available_surplus)}}>{parseAndFormat(allocationDetails.total_available_surplus, 2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{color: getCellColor(allocationDetails.fame_adv_available)}}>Advanced FAME</TableCell>
                  <TableCell style={{color: getCellColor(allocationDetails.fame_adv_available)}}>{parseAndFormat(allocationDetails.fame_adv_available, 2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{color: getCellColor(allocationDetails.hvo_adv_available)}}>Advanced HVO/HRO</TableCell>
                  <TableCell style={{color: getCellColor(allocationDetails.hvo_adv_available)}}>{parseAndFormat(allocationDetails.hvo_adv_available, 2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableBody>
              <TableHead>
                <TableRow>
                  <TableCell>Total mandate surplus AVAILABLE</TableCell>
                  <TableCell>{parseAndFormat(allocationDetails.mandate_surplus_available, 2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
            </Table>
            <Table className={`${classes.table} ${classes.topSpacing}`}>
              <TableHead className="MuiTableCell-head">
                <TableRow>
                  <TableCell style={{ width: "40%", backgroundColor: colorDetailsConventional }}>Conventional biofuel</TableCell>
                  <TableCell style={{ width: "40%", backgroundColor: colorDetailsConventional }}>{allocationDetails.total_conventional_biofuel_status}</TableCell>
                  <TableCell style={{ width: "20%", backgroundColor: colorDetailsConventional }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="MuiTableBody-root">
                <TableRow>
                  <TableCell style={{color: getCellColor(allocationDetails.total_vol_conventional_biofuel)}}>Total volume conventional biofuel</TableCell>
                  <TableCell style={{color: getCellColor(allocationDetails.total_vol_conventional_biofuel)}}>{parseAndFormat(allocationDetails.total_vol_conventional_biofuel, 2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{color: getCellColor(allocationDetails.conventional_fame)}}>Conventional FAME</TableCell>
                  <TableCell style={{color: getCellColor(allocationDetails.conventional_fame)}}>{parseAndFormat(allocationDetails.conventional_fame, 2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{color: getCellColor(allocationDetails.conventional_hvo)}}>Conventional HVO/HRO</TableCell>
                  <TableCell style={{color: getCellColor(allocationDetails.conventional_hvo)}}>{parseAndFormat(allocationDetails.conventional_hvo, 2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableBody>
              <TableHead>
                <TableRow>
                  <TableCell>Total conventional biofuel</TableCell>
                  <TableCell>{parseAndFormat(allocationDetails.total_conventional_biofuel, 2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
            </Table>
            <Table className={`${classes.table} ${classes.topSpacing}`}>
              <TableHead className="MuiTableCell-head">
                <TableRow>
                  <TableCell style={{ width: "40%", backgroundColor: colorDetailsVolume }}>Volume check</TableCell>
                  <TableCell style={{ width: "40%", backgroundColor: colorDetailsVolume }}>{allocationDetails.volume_check_status}</TableCell>
                  <TableCell style={{ width: "20%", backgroundColor: colorDetailsVolume }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="MuiTableBody-root">
                <TableRow>
                  <TableCell style={{color: getCellColor(allocationDetails.joint_fulf_in)}}>Joint fulfillment IN</TableCell>
                  <TableCell style={{color: getCellColor(allocationDetails.joint_fulf_in)}}>{parseAndFormat(allocationDetails.joint_fulf_in, 2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{color: getCellColor(allocationDetails.joint_fulf_out)}}>Joint fulfillment OUT</TableCell>
                  <TableCell style={{color: getCellColor(allocationDetails.joint_fulf_out)}}>{parseAndFormat(allocationDetails.joint_fulf_out, 2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{color: getCellColor(allocationDetails.supplied_adv_biofuel)}}>Supplied advanced biofuel</TableCell>
                  <TableCell style={{color: getCellColor(allocationDetails.supplied_adv_biofuel)}}>{parseAndFormat(allocationDetails.supplied_adv_biofuel, 2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{color: getCellColor(allocationDetails.supplied_conventional_biofuel)}}>Supplied Conevntional biofuel</TableCell>
                  <TableCell style={{color: getCellColor(allocationDetails.supplied_conventional_biofuel)}}>{parseAndFormat(allocationDetails.supplied_conventional_biofuel, 2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableBody>
              <TableHead>
                <TableRow>
                  <TableCell>Total volumes</TableCell>
                  <TableCell>{parseAndFormat(allocationDetails.total_volume, 2)}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
            </Table>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel expanded={expanded.includes("surplus")} onChange={handleAccordionChange("surplus")}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h5" className={classes.cardTitle}>
              Surplus overview
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Table className={classes.table}>
              <TableHead className="MuiTableCell-head">
                <TableRow>
                  <TableCell>LOCKED surplus</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Surplus volume</TableCell>
                  <TableCell>AVAILABLE surplus</TableCell>
                  <TableCell>Surplus volume</TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="MuiTableBody-root">
                <TableRow>
                  <TableCell>Customer requirement</TableCell>
                  <TableCell>Advanced FAME</TableCell>
                  <TableCell>{parseAndFormat(surplusOverview.cust_req_fame_adv_locked, 2)}</TableCell>
                  <TableCell>Advanced FAME</TableCell>
                  <TableCell>{parseAndFormat(surplusOverview.fame_adv_available, 2)}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Customer requirement</TableCell>
                  <TableCell>Advanced HVO/HRO</TableCell>
                  <TableCell>{parseAndFormat(surplusOverview.cust_req_hvo_adv_locked, 2)}</TableCell>
                  <TableCell>Advanced HVO/HRO</TableCell>
                  <TableCell>{parseAndFormat(surplusOverview.hvo_adv_available, 2)}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Joint fulfillment OUT</TableCell>
                  <TableCell>Advanced biofuel</TableCell>
                  <TableCell>{parseAndFormat(surplusOverview.out_joint_biofuel_adv_locked, 2)}</TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
    )}
    <ModalInfo
      text={errorMessage}
      open={showErrorModal}
      onClose={closeErrorModal}
    />
    <ModalConfirmDelivery
      open={showConfirmDeliveryModal}
      onClose={closeConfirmDeliveryModal}
      onConfirm={() => {
        closeConfirmDeliveryModal();
        handleConfirmationStatus();
      }}
    />
  </div>
  );
};

export default ReportsView;
